import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class NumPoints extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.numpoints',
        group: 'Spatial Accessors',
        title: 'ST NumPoints',
        description: `
      This component creates a new table with an additional column with the number
      of points in each input geography.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Redshift:
      case Provider.Postgres:
        return dedent`SELECT *, ST_NPOINTS(${connection.processInputGeogColumn(params.geo as string)})
                  AS ${params.geo}_npoints
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  *, ST_NPOINTS(${connection.processInputGeogColumn(params.geo as string)})
                  AS ${params.geo}_npoints
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Snowflake:
        return dedent`SELECT *, ST_NPOINTS(${params.geo})::BIGINT
                  AS ${params.geo}_npoints
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle: {
        const geoColumn = params.geo as string
        const npointsColumn = `${params.geo}_npoints`
        return dedent`SELECT t.*,
                  SDO_UTIL.GETNUMVERTICES(t.${geoColumn}) AS ${npointsColumn}
                FROM ${connection.quoteName(params.source as string)} t`
      }
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_npoints`,
      type: ColumnDataType.Number
    })
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { NumPoints }
